/**
 * Derives a 256-bit AES-GCM key from a passphrase + salt using PBKDF2.
 * The salt is typically the user's ID — known, stable, not secret.
 *
 * @param {string} passphrase  — password or recovery phrase string
 * @param {string} salt        — user ID (used as PBKDF2 salt)
 * @returns {Promise<CryptoKey>}
 */
export async function deriveKey(passphrase, salt) {
  const enc = new TextEncoder();

  const keyMaterial = await crypto.subtle.importKey(
    'raw',
    enc.encode(passphrase),
    { name: 'PBKDF2' },
    false,
    ['deriveKey'],
  );

  return crypto.subtle.deriveKey(
    {
      name:       'PBKDF2',
      salt:       enc.encode(salt),
      iterations: 100_000,
      hash:       'SHA-256',
    },
    keyMaterial,
    { name: 'AES-GCM', length: 256 },
    false,
    ['encrypt', 'decrypt'],
  );
}
